module.exports = __webpack_public_path__ + "img/close-small-red.72580390.svg";